export default __webpack_public_path__ + "static/media/DarkBlue0003.5675343e.png";